import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, of, tap } from 'rxjs';
import { PlatformEnum } from '@fh-client-interaction-frontends/fh-enums';
import { HttpClient } from '@angular/common/http';
import { FhApplicationSetupModel } from '../../helpers/objects/dto/application-setup/fh-application-setup-model';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Injectable({
  providedIn: 'root'
})
export class FhApplicationSetupService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  private setupSubject = new BehaviorSubject<FhApplicationSetupModel | null>(null);
  setup$ = this.setupSubject.asObservable();

  constructor(@Inject(APP_CONFIG) appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  // getSetup(): Observable<FhApplicationSetupModel> {
  //   if (this.setupSubject.value) {
  //     return of(this.setupSubject.value);
  //   }
  //
  //   let url = '';
  //   switch (this.appConfig.platform) {
  //     case PlatformEnum.salesPortal:
  //       url = this.appConfig.api + 'setup/global/config/' + this.appConfig.apiPartnershipId;
  //       break;
  //     case PlatformEnum.clientPortal:
  //       url = this.appConfig.api + 'setup/global/config';
  //       break;
  //   }
  //
  //   return this.http.get(url).pipe(map((response: any) => response.body.config as FhApplicationSetupModel));
  // }

  getSetup(): Observable<FhApplicationSetupModel> {
    if (this.setupSubject.value) {
      return of(this.setupSubject.value);
    }
    // --- MOCK RESPONSE ---
    const mockResponse = {
      success: true,
      httpStatusCode: 200,
      resultCode: 200,
      resultMessage: "Operação efectuada com sucesso.",
      resultCodeDetail: [],
      body: {
        config: {
          currencyCode: "EUR",
          locale: "pt-PT"
        }
      }
    };
    // Instead of calling the API, just return the mock
    return of(mockResponse.body.config as FhApplicationSetupModel);
  }


  emitSetup(setup: FhApplicationSetupModel) {
    this.setupSubject.next(setup);
  }

  getCurrentSetup(): FhApplicationSetupModel | null {
    return this.setupSubject.value;
  }
}
